import { config } from '../config'

/**
 * Получает полный URL изображения
 * @param {string} imagePath - Относительный путь к изображению
 * @returns {string} Полный URL изображения
 */
export function getImageUrl(imagePath) {
  if (!imagePath) return null;
  
  // Если уже полный URL
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  
  // Получаем базовый URL сервера
  const baseUrl = config.apiUrl;
  
  // Убираем /api из конца если есть
  const serverUrl = baseUrl.replace(/\/api$/, '');
  
  // Убираем начальный слеш из imagePath если есть
  const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
  
  // Формируем полный URL
  return `${serverUrl}/${cleanPath}`;
}

/**
 * Валидирует файл изображения
 * @param {File} file - Файл для валидации
 * @returns {Object} Результат валидации
 */
export function validateImageFile(file) {
  const errors = [];
  
  // Проверяем тип файла
  const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
  if (!allowedTypes.includes(file.type)) {
    errors.push('Недопустимый тип файла. Разрешены: JPEG, PNG, WebP, GIF');
  }
  
  // Проверяем размер файла (5MB)
  const maxSize = 5 * 1024 * 1024;
  if (file.size > maxSize) {
    errors.push('Файл слишком большой. Максимальный размер: 5MB');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}

/**
 * Создает превью изображения
 * @param {File} file - Файл изображения
 * @returns {Promise<string>} URL превью изображения
 */
export function createImagePreview(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      resolve(e.target.result);
    };
    
    reader.onerror = () => {
      reject(new Error('Не удалось создать превью изображения'));
    };
    
    reader.readAsDataURL(file);
  });
} 